import { render, staticRenderFns } from "./NewsletterDesinscription.vue?vue&type=template&id=18279786&scoped=true"
import script from "./NewsletterDesinscription.vue?vue&type=script&lang=js"
export * from "./NewsletterDesinscription.vue?vue&type=script&lang=js"
import style0 from "./NewsletterDesinscription.vue?vue&type=style&index=0&id=18279786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18279786",
  null
  
)

export default component.exports